import React from 'react'
import FaqAccordion from './FaqAccordion'
import { verificationFaqs } from '../../common/constants'

const Faq = () => {
   return (
        <div className='flex flex-col w-full'>
            {verificationFaqs.map(({ question, answer }, index) => (
                <FaqAccordion title={question} key={index} index={index} length={verificationFaqs?.length} content={answer}/>
            ))}
        </div>
    )
}

export default Faq
